import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import categoryUserSitePublisherAction from "../../../../../store/actions/categoryUserSitePublisher";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import helpersNumbers from "../../../../../helpers/numbers";
import typeActionCategoryUserSitePublisher from "../../../../../store/actions/typeActionCategoryUserSitePublisher";

function AllPositionsPageSitePublisher({
  startDate,
  endDate,
  dataSitePublisher,
  addPositionTagToState,
  position_added_in_edit_action,
  addedPositionInEditAction,
  typeAction,
  render,
}) {
  const params = useParams();
  const pageID = parseInt(params.id);
  const [positions, setPositions] = useState([]);
  const [pageData, setPageData] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();
  const history = useHistory();
  useEffect(() => {
    scrollForSeeMessage();
    const initDataComponent = async () => {
      await getPageInSitePublisher();
      await getPositionsPageSitePublisher();
    };
    initDataComponent();
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getPageInSitePublisher = async () => {
    const pageData = await sendRequestGetPageInSitePublisher(pageID);
    setPageData(pageData);
    setSitePublisherData(
      await sendRequestGetSitePublisherData(pageData.web_site_publisher_id)
    );
  };

  const sendRequestGetPageInSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const getPositionsPageSitePublisher = async () => {
    const positionsPageSitePublisher =
      await sendRequestGetPositionsPageSitePublisher(pageID);
    if (!positionsPageSitePublisher) {
      return;
    }

    setPositions(positionsPageSitePublisher);
  };

  const sendRequestGetPositionsPageSitePublisher = async (pageID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/page/alternative/" +
          pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const sendRequestGetSitePublisherData = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return positionsPageSitePublisher.data.data;
  };

  const hasPositionEmptyCampaignBanner = (position) => {
    const newPendingCampaigns =
      getCampaignBannerThatOverrideCampaignDateWithDateGroup(position);
    if (position.count > newPendingCampaigns.length) {
      return true;
    }

    return false;
  };

  const getCampaignBannerThatOverrideCampaignDateWithDateGroup = (position) => {
    const startDateGroup = helpersTime.convertJalaliToGregorian(startDate);
    const endDateGroup = helpersTime.convertJalaliToGregorian(endDate);
    const newCampaigns = [];
    let pendingAlternativeCampaigns = position.pending_alternative;
    for (const key in pendingAlternativeCampaigns) {
      const pendingAlternativeCampaign = pendingAlternativeCampaigns[key];
      const startDateCampaign = pendingAlternativeCampaign.start_date;
      const endDateCampaign = pendingAlternativeCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(pendingAlternativeCampaign);
      }
    }

    let activeAlternativeCampaigns = position.active_alternative;
    for (const key in activeAlternativeCampaigns) {
      const activeAlternativeCampaign = activeAlternativeCampaigns[key];
      const startDateCampaign = activeAlternativeCampaign.start_date;
      const endDateCampaign = activeAlternativeCampaign.end_date;

      if (
        moment(endDateCampaign).diff(startDateGroup, "days") > 0 &&
        moment(endDateGroup).diff(startDateCampaign, "days") > 0
      ) {
        newCampaigns.push(activeAlternativeCampaign);
      }
    }

    return newCampaigns;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector("#select-position-container");
    element.scrollIntoView();
  };

  const generateCheckBoxAddPositionTag = (
    position,
    isChecked,
    addPositionToState
  ) => {
    if (
      isChecked === "checked" &&
      typeAction === typeActionCategoryUserSitePublisher.EDIT &&
      !position_added_in_edit_action.includes(position.tag_html_id)
    ) {
      return;
    }

    return (
      <label className="adl-switch">
        <input
          type="checkbox"
          defaultChecked={isChecked}
          onChange={(e) => {
            addPositionToState(position);
          }}
        />
        <span className="adl-slider round"></span>
      </label>
    );
  };

  const generatePositionsPageSitePublisher = () => {
    return positions.map((position, index) => {
      const isPositionEmptyCampaignBanner =
        hasPositionEmptyCampaignBanner(position);

      let isChecked = "";

      if (dataSitePublisher[pageData.web_site_publisher_id] !== undefined) {
        if (
          dataSitePublisher[pageData.web_site_publisher_id][pageID] !==
          undefined
        ) {
          if (
            dataSitePublisher[pageData.web_site_publisher_id][
              pageID
            ].positions.includes(position.tag_html_id)
          ) {
            isChecked = "checked";
          }
        }
      }

      let classBgPosition = "";
      if (isPositionEmptyCampaignBanner) {
        if (isChecked === "checked") {
          classBgPosition = "bg-primary";
        }
      } else {
        classBgPosition = "bg-danger";
      }

      return (
        <div
          key={index}
          className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
        >
          <div className={classBgPosition}>
            <div className="p-2 d-flex">
              <div className="position-absolute">
                <span>
                  {isPositionEmptyCampaignBanner === true ? (
                    generateCheckBoxAddPositionTag(
                      position,
                      isChecked,
                      addPositionToState
                    )
                  ) : (
                    <></>
                  )}
                  {
                    // <label className="adl-switch">
                    //   <input
                    //     type="checkbox"
                    //     defaultChecked={isChecked}
                    //     onChange={(e) => {
                    //       addPositionToState(position);
                    //     }}
                    //   />
                    //   <span className="adl-slider round"></span>
                    // </label>
                  }
                </span>
              </div>
              <div className="align-items-center justify-content-center d-flex flex-grow-1 letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(position.size)}
              </div>
            </div>

            <div className="px-2 d-flex border-top">
              <div className="py-2 w-50 text-center border-left">
                {helpersNumbers.toPersianNum(` ${position.count} / 1`)}
              </div>
              <div className="py-2 w-50 text-center letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  Math.floor((1 / position.count) * 100)
                )}
                %
              </div>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ جایگاه در حالت جایگزین :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(
                    position.price_alternative
                  )
                )}
              </span>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ پایه جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(position.base_price)
                )}
              </span>
            </div>
            <div dir="ltr" className="p-2 text-center border-top">
              <span>مبلغ جایگاه :‌</span>
              <span className="letter-spacing-finance-number">
                {helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(position.price)
                )}
              </span>
            </div>

            <div dir="ltr" className="p-2 text-center border-top">
              {position.tag_html_id}
            </div>
          </div>
        </div>
      );
    });
  };

  const addPositionToState = (position) => {
    const positionsPriceAlternative = position.price_alternative;

    addPositionTagToState({
      site_publisher_url: sitePublisherData.url.replace("http://", ""),
      web_site_publisher_id: pageData.web_site_publisher_id,
      page_id: pageID,
      page_title: pageData.title,
      position_tag_html_id: position.tag_html_id,
      position_price: positionsPriceAlternative,
    });

    if (typeAction === typeActionCategoryUserSitePublisher.EDIT) {
      addedPositionInEditAction({
        position: position.tag_html_id,
      });
    }
  };

  const checkDataExisiForcalculateAmountThisPage = () => {
    if (pageData === undefined) {
      return false;
    }

    if (sitePublisherData === undefined) {
      return false;
    }
    if (positions.length === 0) {
      return false;
    }

    if (dataSitePublisher[pageData.web_site_publisher_id] === undefined) {
      return false;
    }

    if (
      dataSitePublisher[pageData.web_site_publisher_id][pageID] === undefined
    ) {
      return false;
    }

    if (
      dataSitePublisher[pageData.web_site_publisher_id][pageID].positions
        .length === 0
    ) {
      return false;
    }
    return true;
  };

  const getPricePage = () => {
    if (!checkDataExisiForcalculateAmountThisPage()) {
      return 0;
    }
    return dataSitePublisher[pageData.web_site_publisher_id][pageID].price;
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning  ">
                  <span className="pl-1">جایگاه های تبلیغات</span>
                  <span className="text-danger pr-2">{pageData?.title}</span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="px-2">
                <div className="alert alert-info">
                  <span className="pl-2">
                    <i className="fa fa-info"></i>
                  </span>
                  <span>
                    جایگاه های قرمز به معنای رزور شدن توسط کمپین کاربران است.
                  </span>
                </div>
              </div>

              <div className="px-2">
                <span>مبلغ این صفحه =</span>
                <span className="letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(getPricePage())
                  )}
                </span>
                <span className="pr-2">تومان</span>
              </div>

              <div className="container-fluid" id="select-position-container">
                <div className="row">
                  {positions.length !== 0 ? (
                    generatePositionsPageSitePublisher(positions)
                  ) : (
                    <></>
                  )}
                </div>
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                  }}
                  className="btn btn-primary"
                >
                  ذخیره و بازگشت
                </span>
              </div>
              <div className="p-2">
                <div>
                  <a
                    href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
                    target="_blank"
                  >
                    <img
                      className="border border-success img-fluid"
                      src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.img_name}`}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    addPositionTagToState: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_POSITION,
        payload: action,
      });
    },
    addPriceToPage: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.ADD_PRICE_TO_PAGE,
        payload: action,
      });
    },
    addedPositionInEditAction: (action) => {
      dispatch({
        type: categoryUserSitePublisherAction.POSITION_ADDED_IN_EDIT_ACTION,
        payload: action,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    typeAction: state.categoryUserSitePublisher.type_action,
    position_added_in_edit_action:
      state.categoryUserSitePublisher.position_added_in_edit_action,
    render: state.categoryUserSitePublisher.render,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllPositionsPageSitePublisher);
